import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import formReducer from "./serviceReducer";
import formReducerGlobal from "./serviceReducerGlobala";
import thunk from "redux-thunk";
import { fileToBase64, findBase64ToObjectForRedux, findObjectToBase64ForRedux } from "../tools/tools";

const persistConfig = {
  key: "root",
  storage,
};

const saveToLocalStorage = async (state) => {
  try {
    // const stateWithBase64 = await findBase64ToObjectForRedux(state); // استفاده از نسخه تبدیل شده
    const serializedState = JSON.stringify(state); // تبدیل شی‌ء به رشته JSON
    sessionStorage.setItem("reduxState", serializedState);
  } catch (err) {
    console.error("Error saving state to localStorage:", err);
  }
};

const reduxLocalStorage =
  ({ getState }) =>
  (next) =>
  (action) => {
    const result = next(action);
    const state = getState();
    saveToLocalStorage(state);
    return result;
  };

const persistedReducer = persistReducer(persistConfig, formReducerGlobal);

const loadFromLocalStorage = async () => {
  try {
    const serializedState = sessionStorage.getItem("reduxState");
    if (serializedState === null) {
      return undefined;
    }
    let parserLocal = JSON.parse(serializedState);
    // let temp = await findObjectToBase64ForRedux(parserLocal);
    return parserLocal;
  } catch (err) {
    console.error("Error loading state from localStorage:", err);
    return undefined;
  }
};
const preloadedState = await loadFromLocalStorage();
export const store = configureStore({
  reducer: {
    from: formReducer,
    another: persistedReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  // middleware: [thunk],
  middleware: [reduxLocalStorage],
  // preloadedState: preloadedState,
});

export const persistor = persistStore(store);
